<template>
  <page-header
    :breadcrumbs="breadcrumbs"
    show-rate-limit-counter
  >
    <template #topbar>
      <h1>{{ headerTitle }}</h1>
      <improve-question
        v-if="showImproveQuestion && answered"
        :question="flashcard"
      />
      <rate-limit-counter v-if="flashcardIsRateLimited(flashcard) && showBannerOrCircle === 'circle'" />
      <div
        v-else-if="showProgress && !flashcardIsRateLimited(flashcard)"
        class="progress"
      >
        <div class="counter">
          {{ currentPosition.position }}/{{ currentPosition.total }}
        </div>
        <tour-tip :tourtip-name="'progress'">
          <pure-progress-bar
            :answered="currentPosition.position"
            :total="currentPosition.total"
          />
        </tour-tip>
      </div>
    </template>
    <template #breadcrumbSlot>
      <flashcard-share-popover
        v-if="sharingEnabled"
        :category="category"
        :context="'header'"
        :flashcard="flashcard"
      />
    </template>
  </page-header>
</template>

<script>
import FlashcardSharePopover from '@components/flashcards/flashcard-share-popover';
import ImproveQuestion from '@components/singletons/improveQuestion';
import PageHeader from '@components/singletons/pageHeader';
import PureProgressBar from '@components/progress/PureProgressBar';
import RateLimitCounter from '@/components/singletons/rate-limit-counter.vue';
import TourTip from '@components/singletons/tour-tip';

import CategoriesMixin from '@/mixins/categories';
import GlobalMixin from '@/mixins/global';
import MnemonicsMixin from '@/mixins/mnemonics';
import RateLimitMixin from '@/mixins/rate-limit';

export default {
  components: { FlashcardSharePopover, ImproveQuestion, PageHeader, PureProgressBar, RateLimitCounter, TourTip },
  mixins: [CategoriesMixin, GlobalMixin, MnemonicsMixin, RateLimitMixin],
  props: {
    answered: {
      type: Boolean,
      default: false,
    },
    breadcrumbs: {
      type: Array,
      default: () => [],
    },
    category: {
      type: Object,
    },
    flashcard: {
      type: Object,
      default: () => ({}),
    },
    grouping: {
      type: Object,
    },
    showImproveQuestion: {
      type: Boolean,
      default: false,
    },
    sharingEnabled: {
      type: Boolean,
      default: false,
    },
    showProgress: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
    },
  },
  computed: {
    isScenario() {
      return this.$route.name && this.$route.name.includes('scenario');
    },
    currentPosition() {
      let position = 0;
      let total = 0;
      if (this.category && this.$store.getters['categoryTypes/quizCategoryTypes'].map(ct => ct.id).includes(this.category.categoryTypeId)) {
        total = this.category.counts.total;
        position = (total - this.currentSession.length) + this.currentSession.indexOf(this.flashcard.id) + 1;
      } else if (this.grouping) {
        total = this.grouping.assetAssociations.length;
        position = this.grouping.sortedAssetAssociations.findIndex(aa => aa.assetBId === this.flashcard.id) + 1;
      } else if (this.isScenario) {
        total = this.category?.counts.total;
        position = (total - this.currentSession.length) + this.currentSession.indexOf(this.flashcard.id) + 1;
      } else {
        position = this.currentSession.indexOf(this.flashcard.id) + 1;
        total = this.currentSession.length;
      }

      return {
        position: position,
        total: total,
      };
    },
    currentSession() {
      return this.$store.getters['flashcards/currentSession'];
    },
    improveQuestionRoute() {
      let message = `Improve this question: Question ID ${this.flashcard.id}\nEnter your suggestions after this line:\n`;
      return { name: 'support', query: {...this.currentQuery, ...{message: message}}};
    },
    headerTitle() {
      if (this.title) {
        return this.title;
      } else if (this.category) {
        return this.category.name;
      } else if (this.grouping) {
        return this.grouping.name;
      }
    },
  },
};
</script>

<style lang='scss' scoped>
  .progress {
    margin-left: rem-calc(12);
  }
</style>
